var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareonsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37305 17.5312H5.20996V19.1748C5.20996 21.3877 6.32715 22.5049 8.58301 22.5049H19.3682C21.6025 22.5049 22.7305 21.3877 22.7305 19.1748V8.30371C22.7305 6.09082 21.6025 4.97363 19.3682 4.97363H17.5205V3.33008C17.5205 1.11719 16.3926 0 14.1582 0H3.37305C1.11719 0 0 1.11719 0 3.33008V14.2012C0 16.4141 1.11719 17.5312 3.37305 17.5312ZM3.39453 15.8018C2.32031 15.8018 1.72949 15.2217 1.72949 14.1045V3.42676C1.72949 2.30957 2.32031 1.72949 3.39453 1.72949H14.126C15.1895 1.72949 15.791 2.30957 15.791 3.42676V4.97363H8.58301C6.32715 4.97363 5.20996 6.08008 5.20996 8.30371V15.8018H3.39453ZM8.60449 20.7754C7.54102 20.7754 6.93945 20.1953 6.93945 19.0781V8.40039C6.93945 7.2832 7.54102 6.70312 8.60449 6.70312H19.3359C20.3994 6.70312 21.001 7.2832 21.001 8.40039V19.0781C21.001 20.1953 20.3994 20.7754 19.3359 20.7754H8.60449Z",
    fill: "#FF5733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareonsquare);
export default __webpack_public_path__ + "static/media/square.on.square.50d33ec368146f5a1dfeb1e70e6c4a2c.svg";
export { ForwardRef as ReactComponent };